module.exports = __webpack_public_path__ + "img/birdslife_bottomimage7.86698038.jpg";